import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ngForms from '@angular/forms'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as markdown from '@attain-apps/fe/web/main/lib/markdown'

import * as state from '../../../../../../state'
import * as assistant from '../../../assistant'

import * as conversationList from './conversation-list'
import * as conversationSelector from './conversation-selector'
import * as messageList from './message-list'

/**
 * Page for the Dolomite agent chat interface
 */
@ngCore.Component({
  host: {
    class: 'dolomite-chat-page',
  },
  imports: [
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.layout.widget.Component,
    ds.input.file.Component,
    ds.input.file.Directive,
    ds.input.select.single.Component,
    ds.input.text.Component,
    ds.button.Component,
    ds.loader.Component,
    ds.overlay.centered.Component,
    ds.overlay.confirmation.Component,
    ds.toggleButton.Component,
    markdown.Component,
    ngForms.FormsModule,
    ngCommon.DatePipe,
    conversationSelector.Component,
    messageList.Component,
    assistant.input.Component,
    conversationList.Component,
  ],
  providers: [
    {
      provide: state.assistant.conversational.Group,
      useFactory: () =>
        ngCore
          .inject(state.assistants.Groups)
          .getById(ents.core.agent.Display.Group.Id.PrincetonAscendArchitect),
    },
  ],
  selector: 'atn-dolomite-chat-page',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Toggle for new workspace UI */
  public readonly useNewUiSg = ngCore.signal(true)

  /** @see state.assistant.conversational.Group */
  public readonly assistantGroup = ngCore.inject(
    state.assistant.conversational.Group,
  )

  /** Messages container element reference */
  private readonly _messagesContainerRef =
    ngCore.viewChild<ngCore.ElementRef<HTMLDivElement>>('messagesContainer')

  /**
   *  Retry sending a failed message to a specific agent within this group
   */
  public retryMessage(message: ents.core.agent.Message): void {
    this.assistantGroup.messages.plugins
      .lookup(state.assistant.conversational.messages.plugins.sender.Plugin)
      .get()
      .feature.actions.retryMessage.from('Group.retryMessageToAgent')
      .dispatch({
        messageId: message.id,
      })
  }

  /**
   * Submit a message to a specific agent within this group
   */
  public submitMessage({
    content,
    files,
  }: {
    content: string
    files: File[]
  }): void {
    const conversation =
      this.assistantGroup.conversation.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal()

    const workspace =
      this.assistantGroup.workspace.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal()

    this.assistantGroup.messages.plugins
      .lookup(state.assistant.conversational.messages.plugins.sender.Plugin)
      .get()
      .feature.actions.sendMessage.from('Group.sendMessageToAgent')
      .dispatch({
        content,
        conversationId: conversation?.id,
        files,
        workspaceId: workspace?.id,
      })

    this.assistantGroup.workspace.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from('Dolomite.ChatPage.Workspace.Selection.Changed')
      .dispatch({
        value: undefined,
      })
  }
}
